export const renderAccordion = (div : string) => {
    
    if (document.getElementById(div)) {
        const accordions = document.querySelectorAll<HTMLDivElement>(".animated_accordion");
        console.log("Accordions: ", accordions);

        const openAccordion = (accordion: HTMLDivElement): void => {
            const icon = accordion.querySelector<HTMLDivElement>("span.icon");
            const content = accordion.querySelector<HTMLDivElement>(".accordion_content");
            accordion.classList.add("accordion_active");

            if (content && icon) {
                content.style.maxHeight = "calc(5rem + " + content.scrollHeight + "px";
            }
        };
        
        const closeAccordion = (accordion: HTMLDivElement): void => {
            const content = accordion.querySelector<HTMLDivElement>(".accordion_content");
            const icon = accordion.querySelector<HTMLDivElement>("span.icon");
            if (content && icon) {
                accordion.classList.remove("accordion_active");
                content.style.maxHeight = "0";
            }
        };
        
        accordions.forEach((accordion) => {
            const intro = accordion.querySelector<HTMLDivElement>(".accordion_intro");
            const content = accordion.querySelector<HTMLDivElement>(".accordion_content");
            if (intro && content) {
                intro.onclick = () => {
                    if (content.style.maxHeight != "0px") {
                        closeAccordion(accordion);
                    } else {
                        accordions.forEach((accordion) => closeAccordion(accordion as HTMLDivElement));
                        openAccordion(accordion as HTMLDivElement);
                    }
                };
                intro.onkeydown = (event) => {
                    if (event.key === "Enter") {
                        event.preventDefault();
                        if (content.style.maxHeight != "0px") {
                            closeAccordion(accordion);
                        } else {
                            accordions.forEach((accordion) => closeAccordion(accordion as HTMLDivElement));
                            openAccordion(accordion as HTMLDivElement);
                        }
                    }
                };
            }
        });
    }
}